import React, { useRef, useState } from "react"
import { useSelector } from "react-redux"
import ToDoIconWhite from '../../../../../assests/header/icons/todo-icon-white.png'
import ToDoIconDark from '../../../../../assests/header/icons/todo-icon-dark.png'
import useClickOutside from "../../../../../hooks/useClickOutside"
import ToDo from "../../HeaderDashboard/ToDo"
import IconHeaderBackground from "../IconHeaderBackground"
import classes from '../Icons.module.css'
import { onKeyDown } from "../../../../../service"


const ToDoBtn = () => {

    const [showToDo, setShowToDo] = useState(false)
    const texts = useSelector(state => state.translate.texts);
    const popupRef = useRef(null);


    useClickOutside(popupRef, () => {
        setShowToDo(false);
    });

    function open(e) {
        setShowToDo(prevShowToDo => !prevShowToDo)
    }

    return (
        <div ref={popupRef} className={` ${!showToDo ? classes.Icon : classes.OpenIconImg}`}>
            <img src={` ${showToDo ? ToDoIconDark : ToDoIconWhite}`} alt='TodoIcon' className={classes.IconImg} onClick={(e) => open(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => open(e))} />
            {showToDo && <IconHeaderBackground title={texts.toDo} close={() => setShowToDo(false)}><ToDo /></IconHeaderBackground>}
        </div>
    )
}

export default ToDoBtn